<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmRoomChart from 'src/components/EnergyMonitoring/sections/EmRoomChart.svelte';
	import { Container } from '@Shelly/shelly-design-system';
	import { devices, rooms } from 'src/stores';
	import { getControlsForEnergyConfig } from '../../../../dash-energy-period';
	import { normalizeEnergyConfig } from '../../../../dash-energy-helpers';
	import { getRoomsWithPmDevices } from '../../../../dash-energy-helpers';
	import type { DashEnergyWidgetConfig } from '../../../../dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig<'dashEnergyRoomChart'> | undefined;
	export let staticPreview = false;

	$: config = normalizeEnergyConfig('dashEnergyRoomChart', energyConfig);
	$: previewMode = staticPreview || (energyConfig as { galleryPreview?: boolean })?.galleryPreview;
	$: controls = getControlsForEnergyConfig(config);
	$: fallbackRoomId = ($devices, $rooms, Number(getRoomsWithPmDevices()[0]?.id ?? 0));
	$: roomId = previewMode ? -101 : (config.roomId ?? fallbackRoomId);
</script>

<Container type="glass" noScroll fullHeight>
	<EmRoomChart
		embedded
		{roomId}
		{controls}
		periodId={config.period}
		staticPreview={previewMode}
		previewRoomName="Living room"
	/>
</Container>
